import type { ReactNode } from 'react'

import { EmptyTableContent } from '@/components/ui/empty/empty-table-content.tsx'

export const EmptyMessages = ({ action }: { action?: ReactNode }) => {
  return (
    <EmptyTableContent>
      It looks like you don&#39;t have any messages created yet, click on the{' '}
      <span className="text-primary-500 text-pointer">
        {action ?? 'Add Message'}
      </span>{' '}
      button to do so.
    </EmptyTableContent>
  )
}
